// src/screens/booking/ThemeDetailScreen.js
// 78차 62차: getNext30Days/isKoreanHoliday에 holidayOverrides 반영 — 매장관리자가
// 공휴일 자동차단 중 특정 날짜만 예외 처리(정상 영업)한 경우 그 날은 예약 가능하게.
// 42차: Quick Book 플로우 도입
// 47차: "지금 바로 예약하기" 인라인 배너 제거 (하단 예약하기 버튼 유지)
//       예약 확인 단계 포인트 사용 제거 (포인트는 모집글 전용)
//       주소 + "지도 앱으로 열기" 섹션 추가
// 49차: SuccessBanner → 전체 화면 예약 완료 + 친구 초대 공유 기능 추가
//       (BookingDetailScreen의 success 화면과 동일 구조)
// 51차: 색 theme.js 단일화 — 자체 색 정의 제거, COLORS 참조 / 초록·주황·빨강·파랑 통일
// 55차: incrementViewCount 호출 — 테마 상세 진입 시 조회수 +1 (분석 대시보드 퍼널용)
// 60차: getNext30Days — blockedWeekdays(반복 요일 차단), reservationWindowDays(예약 오픈 기간) 반영
// 72차: 매장명 옆에 "💌 문의하기" 버튼 추가 — WriteInquiryScreen(targetType:'store')으로 이동
// 72차: 매장 일시 휴업(isPaused) 안내 배너 + 예약 버튼 비활성화 추가
// 72차: 디자인 시스템 개편 — "예약하기" 버튼을 공통 GradientButton 컴포넌트로 교체
// 74차: 예약 완료 후 product.reservationUrl(매장 자체 예약 시스템)이 있으면 선택한
//       날짜/시간/인원을 쿼리스트링에 담아 외부 URL로 이동하도록 추가
// 74차: pricing이 빈 배열인 테마(가격 미등록, 예: 계약 전 데모 매장 일부)는 인원
//       선택 단계를 건너뛰면서 selectedPrice가 항상 null이 되어 0원으로 조용히
//       저장되던 버그 수정 — product.price 단일가로 대체하고, 그마저 없으면
//       "가격 미등록" 안내로 제출을 막음. 진단을 위해 Sentry.captureException 추가
// 74차: 메인 화면 자체 커스텀 헤더(DetailHeader) → 공통 AppHeader로 교체. 예약 완료
//       화면(SuccessScreen)의 DetailHeader(onDismiss 커스텀 뒤로가기)는 그대로 유지
// 77차: design 폴더(design_handoff_unlock) 테마 상세 화면 스펙 적용 — 히어로 하단에
//       그라디언트 스크림(rgba(10,10,20,.15)→COLORS.bg) 추가하고 제목/매장/난이도 도트/별점을
//       그 위로 이동(spec 레이아웃), 난이도 표시를 이모지 라벨→원형 도트(BookingDetailScreen.js의
//       DifficultyStars와 동일 패턴)로 통일, 예약 시트의 날짜/시간 선택 칩에 선택 상태(골드
//       그라디언트/골드 아웃라인) 표시 추가. AppHeader는 76차 전수조사로 이미 전 화면에 적용된
//       공통 규칙이라 그대로 유지 — 히어로 위 별도 뒤로가기/찜 아이콘 버튼은 추가하지 않음
//       (AppHeader 뒤로가기와 중복되고, 찜 기능 자체가 이 화면에 없어 신규 기능 추가가 됨).
//       예약/조회 로직, 데이터 흐름은 변경 없음 — 순수 시각 스타일 패스.

// 78차 32차: QuickBookSheet 헤더의 닫기/이전단계(✕/‹) 버튼에 accessibilityLabel 추가(접근성 라벨 전수 점검)
// 80차: 체험형 공연(정원제, product.bookingFormat==='show') 예약 분기 추가 — 시간 슬롯을
//       이진(예약됨/가능) 대신 잔여 정원으로 표시, 인원 선택도 잔여 정원으로 제한, 제출은
//       addReservation 대신 reserveShowSlot(CF) 경유. 방탈출 전세(기본) 경로는 그대로.
// 80차 후속: 난이도→활동성(같은 게이지 컴포넌트 재사용), 인원별 가격표→1인당 단가 한 줄,
//       유의사항/환불정책 섹션 신규(전부 isShowFormat 조건).
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity,
  StyleSheet, ActivityIndicator,
  Dimensions, Modal, Animated, Pressable, Alert, Linking, Share,
} from 'react-native';
// 78차 37차: 테마 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useNavigation, useRoute } from '@react-navigation/native';
import * as WebBrowser from 'expo-web-browser';
import { getReviewsByProduct } from '../../services/reviewService';
import { normalizeProduct, incrementViewCount, getProductById } from '../../services/productService';
import { getBookedTimes, buildReservationRedirectUrl } from '../../services/reservationService';
import { addReservation, getShowSlotCounts, reserveShowSlot } from '../../services/reservationService';
import * as Sentry from '@sentry/react-native';
import { StarRating, ReviewList } from '../../components/common/ReviewCard';
import GradientButton from '../../components/common/GradientButton';
import { SecondaryButton, GenreBadge } from '../../components/common/Buttons';
import { GenreIcon, PeopleIcon, PaymentIcon, MenuReservationIcon, MenuPointsIcon, MenuStoreIcon, LocationIcon, MenuInquiryIcon, IconLabel, StopwatchIcon, DifficultyTargetIcon, DifficultyLockIcon, DifficultyGaugeDots, BookingLockIcon, ShareIcon, CalendarCheckIcon, ClockIcon, CrewNoticeIcon } from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import AppHeader from '../../components/common/AppHeader';
import { useAuth } from '../../contexts/AuthContext';
import { COLORS, GRADIENTS } from '../../constants/theme';
import { getGenreMeta, isKoreanHoliday, getDifficultyLabel, getDifficultyColor, getActivityLabel, getActivityColor, getSeatingTypeLabel } from '../../constants';
import { effectiveWindowDays, isAdultBirth, isConfirmedMinorBirth } from '../../utils/dateUtils';

const { width, height } = Dimensions.get('window');

const GOLD      = COLORS.gold;
const GOLD_BG   = COLORS.goldBg;
const GOLD_BDR  = COLORS.goldBorder;
const BG        = COLORS.bg;
const SURFACE   = COLORS.surface;
const SURFACE2  = COLORS.surface2;
const BORDER    = COLORS.border;
const TEXT      = COLORS.text;
const TEXT_SEC  = COLORS.textSec;
const TEXT_MUTED = COLORS.textMuted;
const RED       = COLORS.red;
const GREEN     = COLORS.green;
const BLUE      = COLORS.blue;
const ON_GOLD   = COLORS.onGold;

// 78차: toISOString()(UTC)이던 것을 로컬 날짜 조립으로 교체 — 이 함수는 예약 날짜 선택
// 캘린더(getNext30Days)의 각 날짜 라벨을 만드는 핵심 함수라, 한국 새벽 0~9시에 실제
// 날짜보다 하루 이른 날짜들이 통째로 나오던(예약 캘린더 전체가 하루씩 밀려 보이던) 버그였음.
const toDateStr = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const isPastSlot = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return false;
  const [year, month, day] = dateStr.split('-').map(Number);
  const [h, m] = timeStr.split(':').map(Number);
  return new Date(year, month - 1, day, h, m, 0, 0) <= new Date();
};
// 60차: blockedWeekdays(반복 요일 차단), windowDays(예약 오픈 기간) 파라미터 추가
// 78차 48차: blockHolidays(공휴일 자동 차단, 기본 true) 파라미터 추가
// 78차 62차: holidayOverrides(개별 예외 처리된 공휴일 날짜) 파라미터 추가
// 78차: windowOpenTime 추가 — "오늘로부터 N일 후 OO시부터 다음 날짜 예약 가능"처럼 매일
// 자정이 아니라 특정 시각에 다음 날짜가 열리는 매장을 위함. 아직 오늘의 오픈 시각이
// 안 지났으면 맨 끝(windowDays번째) 날짜를 하루 늦게 열어준다.
// 78차: windowDays만큼만 배열 자체를 짧게 만들던 것을 — "예약 오픈 기간 외에는 날짜
// 자체가 안 보인다"는 신고로 변경. 항상 30일 전체를 보여주고, 오픈 기간 밖의 날짜는
// blocked와 별개인 windowClosed 플래그로 표시만(흐리게+선택불가) 하도록 함.
// 78차 37차: 위 변경 직후 발견된 회귀 — 루프를 30으로 고정해버려서 windowDays가
// 30보다 큰 매장(WindowDaysPickerModal은 0~180일까지 설정 가능)은 31일차 이후 날짜가
// 흐림처리는커녕 배열에서 아예 사라지는 원래 문제가 그대로 재발하고 있었음 — 오픈
// 기간이 30일보다 길면 그 기간만큼은 항상 다 보이도록 하한을 effDays로 확장.
const getNext30Days = (blockedDates = [], blockedWeekdays = [], windowDays = null, blockHolidays = true, holidayOverrides = [], windowOpenTime = null) => {
  const days = [];
  const today = new Date();
  const effDays = windowDays != null ? effectiveWindowDays(windowDays, windowOpenTime) : null;
  const totalDays = Math.max(30, effDays || 0);
  for (let i = 0; i < totalDays; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    const str = toDateStr(d);
    const dow = d.getDay();
    days.push({
      dateStr: str,
      day: d.getDate(),
      dow: ['일','월','화','수','목','금','토'][dow],
      isSun: dow === 0,
      isSat: dow === 6,
      // 특정 날짜 차단 OR 요일 반복 차단 OR 공휴일 자동 차단 어느 하나라도 해당하면 blocked
      blocked: blockedDates.includes(str) || blockedWeekdays.includes(dow) || (blockHolidays && isKoreanHoliday(str, holidayOverrides)),
      windowClosed: effDays != null && i >= effDays,
    });
  }
  return days;
};

// 78차 37차: 난이도 4단계 표기 — 자물쇠 이모지(🔓🔒🔐⛓️) 4종을 실제 디자인(DesignSync
// "07 추가 요청 아이콘 세트")으로 교체. 단계별로 자물쇠 모양을 바꾸면 형태가 뭉개진다는
// 사용자 피드백에 따라, 자물쇠 아이콘은 4단계 전부 동일(DifficultyLockIcon)하게 두고
// 난이도는 그 옆 DifficultyGaugeDots(채움 도트)만으로 표현 — 텍스트 라벨엔 이제 이모지 없음.
// 78차 39차: 로컬 difficultyLabel/difficultyColor 삭제 — StoreDetailScreen.js와 완전히
// 동일한 내용으로 중복 정의돼 있던 것을 constants/index.js의 getDifficultyLabel/
// getDifficultyColor로 공용화.
// 78차 63차: 이 화면 히어로 오버레이 전용으로 로컬 5단계(easy~expert:1~5, 3 누락) 도트를
// 따로 구현하고 있었음 — 바로 아래(975줄)의 "게임 정보" 카드는 같은 화면인데 정작 올바른
// 4단계 DifficultyGaugeDots를 쓰고 있어 한 화면 안에서도 표기가 어긋나 있었음. 통일.
function DifficultyDots({ difficulty }) {
  return <DifficultyGaugeDots difficulty={difficulty} size={7} gap={4} color={COLORS.goldLight} mutedColor="rgba(255,255,255,0.25)" />;
}
const getPriceMap = (product) => {
  const pricing = product?.pricing || [];
  if (!pricing.length) return {};
  return Object.fromEntries(pricing.map(p => [`${p.people}인`, Number(p.price)]));
};

// 지도 앱으로 열기
const openMapApp = async (address, storeName) => {
  const query = encodeURIComponent(address || storeName || '');
  const kakaoUrl = `kakaomap://search?q=${query}`;
  const naverUrl = `nmap://search?query=${query}&appname=com.roomescapeapp`;
  const webUrl   = `https://map.kakao.com/?q=${query}`;

  try {
    const kakaoSupported = await Linking.canOpenURL(kakaoUrl);
    if (kakaoSupported) { await Linking.openURL(kakaoUrl); return; }
    const naverSupported = await Linking.canOpenURL(naverUrl);
    if (naverSupported) { await Linking.openURL(naverUrl); return; }
    await Linking.openURL(webUrl);
  } catch {
    await Linking.openURL(webUrl).catch(() => {});
  }
};

function DetailHeader({ navigation, title }) {
  return (
    <View style={hd.wrap}>
      <TouchableOpacity style={hd.backBtn} onPress={() => navigation.goBack()} activeOpacity={0.7}>
        <Text style={hd.backArrow}>‹</Text>
        <Text style={hd.backLabel}>뒤로</Text>
      </TouchableOpacity>
      <Text style={hd.title} numberOfLines={1}>{title}</Text>
      <View style={{ width: 60 }} />
    </View>
  );
}
const hd = StyleSheet.create({
  wrap:      { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
               backgroundColor: SURFACE, borderBottomWidth: 1, borderBottomColor: BORDER,
               paddingHorizontal: 16, paddingVertical: 12 },
  backBtn:   { flexDirection: 'row', alignItems: 'center', gap: 2, minWidth: 60 },
  backArrow: { color: GOLD, fontSize: 26, fontWeight: '300', lineHeight: 28, marginTop: -2 },
  backLabel: { color: GOLD, fontSize: 14, fontWeight: '600' },
  title:     { color: TEXT, fontSize: 15, fontWeight: '800', flex: 1, textAlign: 'center', paddingHorizontal: 8 },
});

function SectionHeader({ title, count }) {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 14, gap: 8 }}>
      <View style={{ width: 3, height: 16, backgroundColor: GOLD, borderRadius: 2 }} />
      <Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>{title}</Text>
      {count != null && (
        <View style={{ backgroundColor: GOLD_BG, borderRadius: 10, paddingHorizontal: 8, paddingVertical: 2, borderWidth: 1, borderColor: GOLD_BDR }}>
          <Text style={{ color: GOLD, fontSize: 11, fontWeight: '700' }}>{count}</Text>
        </View>
      )}
    </View>
  );
}

function InfoBadge({ emoji, Icon, label, value, valueColor, extra }) {
  return (
    <View style={ib.wrap}>
      {Icon ? <Icon size={20} color={TEXT_MUTED} /> : <Text style={ib.emoji}>{emoji}</Text>}
      <Text style={ib.label}>{label}</Text>
      <Text style={[ib.value, valueColor && { color: valueColor }]}>{value}</Text>
      {extra}
    </View>
  );
}
const ib = StyleSheet.create({
  wrap:  { flex: 1, backgroundColor: SURFACE2, borderRadius: 12, padding: 14, alignItems: 'center', gap: 4, borderWidth: 1, borderColor: BORDER },
  emoji: { fontSize: 22 },
  label: { color: TEXT_MUTED, fontSize: 10, fontWeight: '600' },
  value: { color: TEXT, fontSize: 13, fontWeight: '700', textAlign: 'center' },
});

function PriceRow({ people, price }) {
  return (
    <View style={pr.row}>
      <Text style={pr.people}>{people}인</Text>
      <Text style={pr.price}>{Number(price).toLocaleString()}원</Text>
    </View>
  );
}
const pr = StyleSheet.create({
  row:    { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: BORDER },
  people: { color: TEXT_SEC, fontSize: 14 },
  price:  { color: GOLD, fontSize: 15, fontWeight: '700' },
});

// ── QuickBook 바텀시트 ────────────────────────────────────────
// 47차: 포인트 사용 UI 완전 제거
function QuickBookSheet({ visible, product, onClose, onSuccess, navigation }) {
  const { user, profile } = useAuth();
  const slideAnim = useRef(new Animated.Value(height)).current;

  const [step,           setStep]           = useState('date');
  const [selectedDate,   setSelectedDate]   = useState(null);
  const [selectedTime,   setSelectedTime]   = useState(null);
  const [selectedPeople, setSelectedPeople] = useState(null);
  const [bookedTimes,    setBookedTimes]    = useState(new Set());
  // 80차: 체험형 공연(정원제) — 시간대별 "이미 찬 인원수"를 담는 Map. 방탈출 전세
  // (bookedTimes, 이진 Set)와 완전히 별개 상태로 둔다.
  const [slotCounts,     setSlotCounts]     = useState(new Map());
  const [loadingSlots,   setLoadingSlots]   = useState(false);
  const [submitting,     setSubmitting]     = useState(false);

  const isShowFormat = product?.bookingFormat === 'show';
  const capacity = Number(product?.capacity) || 0;

  const priceMap = useMemo(() => getPriceMap(product), [product?.id]);
  const hasPriceMap = Object.keys(priceMap).length > 0;
  // 74차: pricing이 비어있는 테마(예: 데모 매장 일부)는 인원 선택 단계 자체가 없으므로
  // product.price(단일가)로 대체 — 이전엔 이 경우 항상 null이 되어 가격 0원으로 저장됐음
  const selectedPrice = hasPriceMap ? (selectedPeople ? priceMap[selectedPeople] : null) : (product?.price ?? null);

  const days = useMemo(() => getNext30Days(
    product?.blockedDates     || [],
    product?.blockedWeekdays  || [],
    product?.reservationWindowDays ?? null,
    product?.blockHolidays !== false,
    product?.holidayOverrides || [],
    product?.reservationWindowOpenTime || null,
  ), [product?.id]);

  const generateTimes = (start, end, interval) => {
    if (!start || !end) return [];
    // 79차: [버그 수정] interval이 0 이하(음수 준비시간 등으로 duration+prepMinutes가
    // 0 이하가 될 수 있음, StoreAdminScreen.js 주석 참고)이면 t += interval이 무한루프가
    // 되어 화면이 완전히 멈춤 — 실제로 Node에서 재현 확인(3초 타임아웃으로 강제종료됨).
    // StoreAdminScreen.js의 generateSlots/SuperAdminStoresScreen.js의 generateBulkSlots엔
    // 이미 이 가드가 있었는데, 형제 함수인 이 고객용 화면 쪽엔 빠져 있었음.
    interval = Math.max(1, Number(interval) || 1);
    const times = [];
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);
    const startMin = sh * 60 + sm;
    let endMin = eh * 60 + em;
    // 78차 44차: 자정을 넘기는 영업시간(예: 22:00~02:00) 지원 — StoreAdminScreen.js의
    // generateSlots와 동일한 처리.
    if (endMin <= startMin) endMin += 24 * 60;
    for (let t = startMin; t < endMin; t += interval) {
      const wrapped = t % (24 * 60);
      times.push(`${String(Math.floor(wrapped / 60)).padStart(2, '0')}:${String(wrapped % 60).padStart(2, '0')}`);
    }
    return times;
  };

  const availableTimes = useMemo(() => {
    const stored = product?.availableTimes || [];
    if (stored.length > 0) return stored;
    return generateTimes(product?.startTime, product?.endTime, Number(product?.intervalMinutes) || Number(product?.duration) || 60);
  }, [product?.id]);

  useEffect(() => {
    if (visible) {
      setStep('date');
      setSelectedDate(null);
      setSelectedTime(null);
      setSelectedPeople(null);
      Animated.spring(slideAnim, { toValue: 0, useNativeDriver: true, tension: 65, friction: 11 }).start();
    } else {
      Animated.timing(slideAnim, { toValue: height, duration: 240, useNativeDriver: true }).start();
    }
  }, [visible]);

  const handleDateSelect = async (dateStr) => {
    setSelectedDate(dateStr);
    setSelectedTime(null);
    setLoadingSlots(true);
    try {
      if (isShowFormat) {
        setSlotCounts(await getShowSlotCounts(product.id, dateStr));
      } else {
        setBookedTimes(await getBookedTimes(product.id, dateStr));
      }
    } catch {
      setBookedTimes(new Set());
      setSlotCounts(new Map());
    } finally {
      setLoadingSlots(false);
      setStep('time');
    }
  };

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
    if (Object.keys(priceMap).length > 0) {
      setStep('people');
    } else {
      setStep('confirm');
    }
  };

  const handlePeopleSelect = (people) => {
    setSelectedPeople(people);
    setStep('confirm');
  };

  const handleSubmit = async () => {
    if (!user) {
      onClose();
      navigation.navigate('Login');
      return;
    }
    // 74차: 가격 정보가 전혀 없는 테마(pricing 빈 배열 + 단일가 없음)는 0원으로
    // 조용히 저장되던 것을 방지 — 예: 계약 전 데모 매장 일부는 pricing:[]로 비워둠
    if (selectedPrice == null) {
      showAlert('예약 불가', '이 테마는 아직 가격 정보가 등록되지 않았어요. 매장에 문의해주세요.');
      return;
    }
    // 80차 후속: 19금 테마 — 생년월일 미입력도 "확인 불가"로 차단(안전한 기본값).
    // 서버(onNewReservation/reserveShowSlotCF)도 동일하게 검증하니 우회는 못 하고,
    // 여기선 빠른 안내용.
    if (product?.isAdultOnly && !isAdultBirth(profile?.birth)) {
      showAlert('19세 이상 이용 가능', '이 테마는 만 19세 이상만 예약할 수 있어요.\n마이페이지에서 생년월일을 등록해주세요.');
      return;
    }
    setSubmitting(true);
    try {
      if (isShowFormat) {
        // 80차: 정원 검증/증감이 서버 트랜잭션에서만 이뤄져야 해서 CF 경유
        await reserveShowSlot({
          productId: product.id,
          productName: product.name,
          storeId: product.storeId || null,
          storeName: product.storeName,
          branchName: product.branchName || product.storeName,
          date: selectedDate,
          time: selectedTime,
          duration: product.duration || 60,
          people: selectedPeople,
          genre: product.genres?.[0] || product.genre || null,
        });
      } else {
        const params = {
          uid: user.uid,
          productId: product.id,
          productName: product.name,
          themeName: product.name,
          storeId: product.storeId || null,
          storeName: product.storeName,
          branchName: product.branchName || product.storeName,
          date: selectedDate,
          time: selectedTime,
          duration: product.duration || 60,
          people: selectedPeople,
          price: selectedPrice,
          originalPrice: selectedPrice,
          usedPoints: 0,
          success: null,
          reviewed: false,
          cancelled: false,
          genre: product.genres?.[0] || product.genre || null,
          paymentType: 'external',
        };
        await addReservation(params);
      }
      if (product.reservationUrl) {
        const url = buildReservationRedirectUrl(product.reservationUrl, {
          date: selectedDate, time: selectedTime, people: selectedPeople,
        });
        // 78차 39차: 매장 자체 예약 사이트가 date/time/people 쿼리스트링을 실제로 읽어서
        // 자동 선택해주는지는 사이트마다 달라 보장이 안 됨(대부분 못 읽음, 실측 확인됨) —
        // 사이트로 넘어가기 전에 선택한 정보를 요약해 보여줘서 사용자가 그 사이트에서
        // 빠르게 다시 입력할 수 있게 함.
        // 80차 후속: Linking.openURL()은 앱을 완전히 벗어나 별도 브라우저 앱으로 나가버려서
        // 고객 이탈로 이어질 수 있었음 — expo-web-browser(SFSafariViewController/Custom Tabs
        // 기반 인앱 브라우저)로 교체, 앱을 벗어나지 않고 그대로 예약 사이트를 띄움.
        // 80차 계속: 드물게 예약 사이트가 임베디드 브라우저에서 이상 동작할 가능성에 대비해
        // "브라우저에서 열기"(기존 방식) 선택지를 안전장치로 함께 제공.
        showAlert(
          '예약 사이트 열기',
          `${product.storeName || '매장'}의 예약 시스템에서 아래 내용으로 마저 예약을 진행해주세요.\n\n테마: ${product.name}\n날짜: ${selectedDate}\n시간: ${selectedTime}${selectedPeople ? `\n인원: ${selectedPeople}` : ''}`,
          [
            { text: '인앱으로 열기', onPress: () => WebBrowser.openBrowserAsync(url).catch(() => {}) },
            { text: '브라우저에서 열기', style: 'cancel', onPress: () => Linking.openURL(url).catch(() => {}) },
          ],
        );
      }
      onSuccess({ selectedDate, selectedTime, selectedPeople, finalPrice: selectedPrice });
    } catch (e) {
      if (e.message === 'SLOT_TAKEN' || e.message === 'SLOT_FULL') {
        showAlert(
          '예약 마감',
          isShowFormat
            ? '방금 정원이 모두 찼어요.\n다른 시간을 선택해주세요.'
            : '방금 다른 분이 해당 시간을 예약했어요.\n다른 시간을 선택해주세요.',
        );
        setStep('time');
        if (isShowFormat) {
          setSlotCounts(await getShowSlotCounts(product.id, selectedDate).catch(() => new Map()));
        } else {
          setBookedTimes(await getBookedTimes(product.id, selectedDate).catch(() => new Set()));
        }
        setSelectedTime(null);
      } else if (e.message === 'AGE_RESTRICTED') {
        // 80차 후속: 클라이언트 소프트 게이트를 우회해도(직접 CF 호출 등) 서버가 최종 차단
        showAlert('19세 이상 이용 가능', '이 테마는 만 19세 이상만 예약할 수 있어요.\n마이페이지에서 생년월일을 등록해주세요.');
      } else {
        // 74차: 이 catch로 빠지는 실제 원인을 Sentry 없이는 재현할 방법이 없어 진단이
        // 불가능했음 — 다음부터는 Sentry 대시보드에서 스택트레이스 확인 가능
        // 78차: "예약 중 오류" 신고가 재발했는데 정적 분석만으로는 원인을 확정하지 못해,
        // 사용자가 화면에서 바로 에러 코드를 확인/캡처할 수 있도록 Alert 문구에 code를 덧붙임
        Sentry.captureException(e, { tags: { flow: 'quick_book_submit' } });
        showAlert('오류', `예약 중 오류가 발생했습니다.${e?.code ? `\n(${e.code})` : ''}`);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const SHEET_H = height * 0.72;

  // 오늘 fork 재검토(이모지→아이콘 전수)로 발견/수정: 이 값이 순수 문자열이라 그동안
  // JSX 아이콘을 못 넣고 이모지로만 남아있었음 — {Icon,label} 쌍으로 바꾸고 렌더 지점
  // (아래 headerTitle Text)만 IconLabel로 교체.
  const stepTitle = {
    date:    { Icon: CalendarCheckIcon, label: '날짜 선택' },
    time:    { Icon: ClockIcon, label: `시간 선택 · ${selectedDate}` },
    people:  { Icon: PeopleIcon, label: `인원 선택 · ${selectedTime}` },
    confirm: { Icon: CrewNoticeIcon, label: '예약 확인' },
  }[step];

  const goBack = () => {
    if (step === 'time')    setStep('date');
    else if (step === 'people')  setStep('time');
    else if (step === 'confirm') setStep(Object.keys(priceMap).length > 0 ? 'people' : 'time');
    else onClose();
  };

  return (
    <Modal visible={visible} transparent animationType="none" onRequestClose={onClose}>
      <Pressable style={qb.dim} onPress={onClose} />
      <Animated.View style={[qb.sheet, { height: SHEET_H, transform: [{ translateY: slideAnim }] }]}>
        <View style={qb.handle} />
        <View style={qb.header}>
          <TouchableOpacity onPress={goBack} style={qb.headerBack} accessibilityLabel={step === 'date' ? '닫기' : '이전 단계'}>
            <Text style={qb.headerBackText}>{step === 'date' ? '✕' : '‹'}</Text>
          </TouchableOpacity>
          <IconLabel Icon={stepTitle.Icon} size={14} color={TEXT} textStyle={{ color: TEXT, fontSize: 14, fontWeight: '800' }} style={{ flex: 1, justifyContent: 'center' }}>{stepTitle.label}</IconLabel>
          <View style={{ width: 36 }} />
        </View>

        <View style={qb.stepRow}>
          {(['date','time','people','confirm']).map((s, i) => {
            const steps = Object.keys(priceMap).length > 0
              ? ['date','time','people','confirm']
              : ['date','time','confirm'];
            if (!steps.includes(s)) return null;
            const idx     = steps.indexOf(s);
            const curIdx  = steps.indexOf(step);
            const done    = idx < curIdx;
            const active  = idx === curIdx;
            return (
              <React.Fragment key={s}>
                {idx > 0 && <View style={[qb.stepLine, done && qb.stepLineDone]} />}
                <View style={[qb.stepDot, active && qb.stepDotActive, done && qb.stepDotDone]}>
                  <Text style={[qb.stepDotText, (active || done) && { color: BG }]}>
                    {done ? '✓' : idx + 1}
                  </Text>
                </View>
              </React.Fragment>
            );
          })}
        </View>

        {step === 'date' && (
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{ paddingHorizontal: 20, paddingVertical: 12, gap: 8 }}
            style={{ flexGrow: 0 }}
          >
            {days.map(d => {
              const blocked = d.blocked;
              // 78차: windowClosed(예약 오픈 기간 밖) — blocked와 시각적으로는 동일하게
              // 흐리게 처리하되, "차단"이 아니라 "아직 안 열림"이라 ✕ 대신 자물쇠로 구분.
              const disabled = blocked || d.windowClosed;
              const selected = d.dateStr === selectedDate;
              // 77차: design 스펙 — 선택된 날짜는 골드 그라디언트 fill
              const Wrap = selected ? LinearGradient : View;
              const wrapProps = selected ? { colors: GRADIENTS.button, start: { x: 0, y: 0 }, end: { x: 1, y: 1 } } : {};
              return (
                <TouchableOpacity
                  key={d.dateStr}
                  onPress={() => !disabled && handleDateSelect(d.dateStr)}
                  disabled={disabled}
                  activeOpacity={0.75}
                >
                  <Wrap {...wrapProps} style={[qb.dayChip, disabled && qb.dayChipBlocked, selected && qb.dayChipSelectedBorder]}>
                    <Text style={[
                      qb.dayDow,
                      d.isSun && { color: RED },
                      d.isSat && { color: BLUE },
                      disabled && { color: TEXT_MUTED },
                      selected && { color: ON_GOLD },
                    ]}>{d.dow}</Text>
                    <Text style={[qb.dayNum, disabled && { color: TEXT_MUTED }, selected && { color: ON_GOLD }]}>{d.day}</Text>
                    {blocked && <Text style={{ color: RED, fontSize: 9, fontWeight: '700' }}>✕</Text>}
                    {!blocked && d.windowClosed && <Text style={{ color: TEXT_MUTED, fontSize: 9, fontWeight: '700' }}>🔒</Text>}
                  </Wrap>
                </TouchableOpacity>
              );
            })}
          </ScrollView>
        )}

        {step === 'time' && (
          <ScrollView contentContainerStyle={{ padding: 20 }} showsVerticalScrollIndicator={false}>
            {loadingSlots ? (
              <ActivityIndicator color={GOLD} style={{ marginTop: 40 }} />
            ) : availableTimes.length === 0 ? (
              <Text style={{ color: TEXT_MUTED, textAlign: 'center', marginTop: 40, fontStyle: 'italic' }}>
                운영 시간 정보가 없습니다.
              </Text>
            ) : (
              <View style={qb.timeGrid}>
                {availableTimes.map(time => {
                  const isPast = isPastSlot(selectedDate, time);
                  // 80차: 체험형 공연은 이진(예약됨/가능)이 아니라 잔여 정원 기준
                  const remaining = isShowFormat ? Math.max(0, capacity - (slotCounts.get(time) || 0)) : null;
                  const unavail = isShowFormat ? (isPast || remaining <= 0) : (bookedTimes.has(time) || isPast);
                  const selected  = time === selectedTime;
                  return (
                    <TouchableOpacity
                      key={time}
                      style={[qb.timeChip, unavail && qb.timeChipUnavail, selected && qb.timeChipSelected]}
                      onPress={() => !unavail && handleTimeSelect(time)}
                      disabled={unavail}
                      activeOpacity={0.75}
                    >
                      <Text style={[
                        qb.timeChipText,
                        unavail && { color: TEXT_MUTED, textDecorationLine: 'line-through' },
                        selected && { color: COLORS.goldLight },
                      ]}>{time}</Text>
                      {unavail && <Text style={qb.timeUnavailText}>마감</Text>}
                      {!unavail && isShowFormat && <Text style={qb.timeRemainingText}>{remaining}석 남음</Text>}
                    </TouchableOpacity>
                  );
                })}
              </View>
            )}
          </ScrollView>
        )}

        {step === 'people' && (
          <ScrollView contentContainerStyle={{ padding: 20 }} showsVerticalScrollIndicator={false}>
            <View style={qb.peopleGrid}>
              {Object.entries(priceMap).map(([label, price]) => {
                // 80차: 체험형 공연은 선택한 시간대의 잔여 정원보다 큰 인원수는 선택 불가
                const remaining = isShowFormat ? Math.max(0, capacity - (slotCounts.get(selectedTime) || 0)) : null;
                const full = isShowFormat && parseInt(label, 10) > remaining;
                return (
                  <TouchableOpacity
                    key={label}
                    style={[qb.peopleChip, full && qb.peopleChipDisabled]}
                    onPress={() => !full && handlePeopleSelect(label)}
                    disabled={full}
                    activeOpacity={0.8}
                  >
                    <Text style={[qb.peopleChipLabel, full && { color: TEXT_MUTED }]}>{label}</Text>
                    <Text style={[qb.peopleChipPrice, full && { color: TEXT_MUTED }]}>{Number(price).toLocaleString()}원</Text>
                    <Text style={qb.peopleChipArrow}>{full ? '정원마감' : '→'}</Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          </ScrollView>
        )}

        {step === 'confirm' && (
          <ScrollView contentContainerStyle={{ padding: 20 }} showsVerticalScrollIndicator={false}>
            <View style={qb.confirmCard}>
              {[
                [GenreIcon, '테마',  product.name],
                [MenuReservationIcon, '날짜',  selectedDate],
                [MenuPointsIcon, '시간',  selectedTime],
                ...(selectedPeople ? [[PeopleIcon, '인원', selectedPeople]] : []),
              ].map(([Icon, label, val]) => (
                <View key={label} style={qb.confirmRow}>
                  <View style={qb.confirmLabelRow}>
                    <Icon size={13} color={TEXT_MUTED} />
                    <Text style={qb.confirmLabel}>{label}</Text>
                  </View>
                  <Text style={qb.confirmValue}>{val}</Text>
                </View>
              ))}

              {selectedPrice != null && (
                <View style={[qb.confirmRow, { borderTopWidth: 1, borderTopColor: BORDER, marginTop: 8, paddingTop: 12 }]}>
                  <View style={qb.confirmLabelRow}>
                    <PaymentIcon size={13} color={TEXT} />
                    <Text style={[qb.confirmLabel, { color: TEXT, fontWeight: '800' }]}>현장 결제</Text>
                  </View>
                  <Text style={[qb.confirmValue, { color: GOLD, fontSize: 18, fontWeight: '900' }]}>
                    {selectedPrice.toLocaleString()}원
                  </Text>
                </View>
              )}
            </View>

            <View style={qb.noticeBox}>
              <Text style={qb.noticeText}>💡 결제는 현장에서 진행됩니다.</Text>
            </View>

            <TouchableOpacity
              style={[qb.submitBtn, submitting && { opacity: 0.7 }]}
              onPress={handleSubmit}
              disabled={submitting}
              activeOpacity={0.85}
            >
              {submitting
                ? <ActivityIndicator color={BG} />
                : <Text style={qb.submitBtnText}>
                    {user ? '예약 신청하기' : '로그인 후 예약하기'}
                  </Text>
              }
            </TouchableOpacity>
          </ScrollView>
        )}
      </Animated.View>
    </Modal>
  );
}

const qb = StyleSheet.create({
  dim:            { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.65)' },
  sheet:          { position: 'absolute', bottom: 0, left: 0, right: 0, backgroundColor: SURFACE,
                    borderTopLeftRadius: 24, borderTopRightRadius: 24,
                    borderWidth: 1, borderColor: BORDER, borderBottomWidth: 0 },
  handle:         { alignSelf: 'center', width: 36, height: 4, backgroundColor: 'rgba(255,255,255,0.15)',
                    borderRadius: 2, marginTop: 12, marginBottom: 4 },
  header:         { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
                    paddingHorizontal: 20, paddingVertical: 14,
                    borderBottomWidth: 1, borderBottomColor: BORDER },
  headerBack:     { width: 36, height: 36, justifyContent: 'center', alignItems: 'center',
                    backgroundColor: SURFACE2, borderRadius: 18 },
  headerBackText: { color: GOLD, fontSize: 20, fontWeight: '700', lineHeight: 22 },

  stepRow:        { flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
                    paddingVertical: 14, paddingHorizontal: 32, gap: 0 },
  stepDot:        { width: 24, height: 24, borderRadius: 12, backgroundColor: SURFACE2,
                    borderWidth: 1.5, borderColor: BORDER,
                    justifyContent: 'center', alignItems: 'center' },
  stepDotActive:  { backgroundColor: GOLD, borderColor: GOLD },
  stepDotDone:    { backgroundColor: GREEN, borderColor: GREEN },
  stepDotText:    { color: TEXT_MUTED, fontSize: 10, fontWeight: '800' },
  stepLine:       { flex: 1, height: 2, backgroundColor: BORDER, marginHorizontal: 4 },
  stepLineDone:   { backgroundColor: GREEN },

  dayChip:        { width: 50, alignItems: 'center', paddingVertical: 12, borderRadius: 14,
                    borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE2, gap: 4 },
  dayChipBlocked: { opacity: 0.3 },
  dayChipSelectedBorder: { borderColor: 'transparent' },
  dayDow:         { color: TEXT_MUTED, fontSize: 11, fontWeight: '600' },
  dayNum:         { color: TEXT, fontSize: 17, fontWeight: '800' },

  timeGrid:       { flexDirection: 'row', flexWrap: 'wrap', gap: 10 },
  // 77차: design 스펙 — 기본은 중립(surface/border), 선택 시에만 골드 아웃라인
  timeChip:       { width: '30%', paddingVertical: 14, borderRadius: 12,
                    borderWidth: 1, borderColor: BORDER,
                    backgroundColor: SURFACE, alignItems: 'center', gap: 4 },
  timeChipSelected:{ borderColor: GOLD + '80', backgroundColor: SURFACE2 },
  timeChipUnavail:{ borderColor: BORDER, backgroundColor: SURFACE2, opacity: 0.45 },
  timeChipText:   { color: TEXT, fontSize: 15, fontWeight: '700' },
  timeUnavailText:{ color: RED, fontSize: 9, fontWeight: '800' },
  // 80차: 체험형 공연 잔여 정원 표시
  timeRemainingText: { color: TEXT_MUTED, fontSize: 9, fontWeight: '700' },

  peopleGrid:     { gap: 10 },
  peopleChip:     { flexDirection: 'row', alignItems: 'center',
                    backgroundColor: SURFACE2, borderRadius: 14,
                    borderWidth: 1.5, borderColor: BORDER,
                    paddingHorizontal: 20, paddingVertical: 16 },
  // 80차: 체험형 공연 — 잔여 정원보다 큰 인원수 선택 비활성화
  peopleChipDisabled: { opacity: 0.4 },
  peopleChipLabel:{ color: TEXT, fontSize: 16, fontWeight: '800', flex: 1 },
  peopleChipPrice:{ color: GOLD, fontSize: 15, fontWeight: '700', marginRight: 12 },
  peopleChipArrow:{ color: GOLD, fontSize: 18, fontWeight: '900' },

  confirmCard:    { backgroundColor: SURFACE2, borderRadius: 16, padding: 18,
                    borderWidth: 1, borderColor: BORDER, marginBottom: 14 },
  confirmRow:     { flexDirection: 'row', justifyContent: 'space-between',
                    alignItems: 'center', paddingVertical: 8 },
  confirmLabelRow:{ flexDirection: 'row', alignItems: 'center', gap: 6 },
  confirmLabel:   { color: TEXT_MUTED, fontSize: 13 },
  confirmValue:   { color: TEXT, fontSize: 13, fontWeight: '700', flex: 1, textAlign: 'right' },
  noticeBox:      { backgroundColor: GOLD + '0D', borderRadius: 10, padding: 12,
                    borderWidth: 1, borderColor: BORDER, marginBottom: 16 },
  noticeText:     { color: TEXT_SEC, fontSize: 12 },
  submitBtn:      { backgroundColor: GOLD, borderRadius: 14, height: 56,
                    justifyContent: 'center', alignItems: 'center',
                    shadowColor: GOLD, shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.35, shadowRadius: 10, elevation: 6 },
  submitBtnText:  { color: BG, fontSize: 16, fontWeight: '900' },
});

// 49차: SuccessBanner → SuccessScreen (전체 화면 + 친구 초대 공유)
// 77차: design 폴더 예약 완료 화면 스펙 적용(QR 제외) — BookingDetailScreen.js의 재예약
// 플로우 성공 화면과 동일한 티켓 카드 스타일로 통일(같은 "예약 완료" 화면이 두 진입 경로
// 마다 다르게 보이지 않도록). 공유/확인 두 기존 동작은 그대로 유지.
function SuccessScreen({ data, product, navigation, onDismiss }) {
  // 78차 49차: 외부 예약 사이트로 안내되는 테마는 앱이 그 사이트에서의 실제 완료 여부를
  // 확인할 방법이 없다(자체 결제/예약 API 연동이 없음) — "예약 완료"라고 단정하지 않고,
  // 앱에는 신청 내용이 접수됐고 실제 확정은 매장 사이트에서 마저 진행해야 함을 명확히 안내.
  const isExternal = !!product.reservationUrl;
  const handleShare = async () => {
    try {
      // 80차: 지금까지 이 공유 메시지에 실제 링크가 없어서(NavigationContainer의 웹
      // URL 동기화가 78차41차부터 꺼져 있어 앱 안으로 바로 연결할 방법이 없었음) 받는
      // 사람이 직접 앱을 열어 검색해야 했음 — themeShareCF 공개 페이지 링크로 대체.
      // 80차 후속: url을 message 문자열 안에만 넣으면 안드로이드는 메시지에 포함된
      // 링크를 각 앱이 알아서 인식해 미리보기를 만들어주지만, iOS/웹(navigator.share)은
      // 별도 url 필드가 있어야 "링크"로 인식해 미리보기 카드를 붙여줌(웹에서 공유 시
      // 일반 텍스트 아이콘만 뜨던 신고의 원인) — 두 플랫폼 다 되도록 url도 함께 전달.
      const shareUrl = `https://unlockapp.co.kr/t/${product.id}`;
      await Share.share({
        message: `[방탈출 같이 해요! 🔐]\n테마: ${product.name}\n📅 ${data.selectedDate} ${data.selectedTime}${data.selectedPeople ? `\n👥 ${data.selectedPeople}` : ''}\n\n${shareUrl}`,
        url: shareUrl,
        title: `${product.name} 같이 해요!`,
      });
    } catch {}
  };

  return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <DetailHeader navigation={{ goBack: onDismiss }} title={isExternal ? '예약 신청 완료' : '예약 완료'} />
      <ScrollView contentContainerStyle={ss.scrollContent}>
        <View style={ss.successMarkWrap}>
          <View style={ss.successMark}><Text style={ss.successCheck}>✓</Text></View>
          <Text style={ss.title}>{isExternal ? '예약 신청이 접수됐어요' : '예약이 확정됐어요'}</Text>
          <Text style={ss.sub}>
            {isExternal
              ? `${product.storeName || '매장'} 예약 시스템에서\n예약을 마저 완료해야 실제 예약이 확정돼요.`
              : '예약이 접수됐어요.\n현장에서 결제해주세요.'}
          </Text>
        </View>

        <View style={ss.ticketCard}>
          <View style={ss.ticketHeader}>
            {product.thumbnailUrl ? (
              <Image source={{ uri: product.thumbnailUrl }} style={ss.ticketThumb} />
            ) : <View style={[ss.ticketThumb, { backgroundColor: SURFACE2 }]} />}
            <View style={{ flex: 1, minWidth: 0 }}>
              <Text style={ss.ticketName} numberOfLines={1}>{product.name}</Text>
              <Text style={ss.ticketStore} numberOfLines={1}>{product.storeName}</Text>
            </View>
            {!!product.genres?.[0] && (
              <GenreBadge label={product.genres[0]} color={getGenreMeta(product.genres[0]).color} />
            )}
          </View>
          <View style={ss.ticketBody}>
            {[
              [GenreIcon, '테마',     product.name],
              [MenuReservationIcon, '날짜',     data.selectedDate],
              [MenuPointsIcon, '시간',     data.selectedTime],
              ...(data.selectedPeople ? [[PeopleIcon, '인원', data.selectedPeople]] : []),
              ...(data.finalPrice != null ? [[PaymentIcon, '현장 결제', `${data.finalPrice.toLocaleString()}원`]] : []),
            ].map(([Icon, label, value]) => (
              <View key={label} style={ss.summaryRow}>
                <View style={ss.summaryLabelRow}>
                  <Icon size={13} color={TEXT_MUTED} />
                  <Text style={ss.summaryLabel}>{label}</Text>
                </View>
                <Text style={ss.summaryValue}>{value}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={ss.noticeBox}>
          <Text style={ss.noticeText}>
            {isExternal
              ? '💡 방금 이동 안내된 사이트에서 예약을 완료해야 확정돼요.\n앱에서 취소해도 매장 사이트 예약은 자동 연동되지 않아요.'
              : '💡 결제는 현장에서 진행됩니다.\n예약 취소 시 앱에서 취소해주세요.'}
          </Text>
        </View>

        <View style={{ width: '100%', marginTop: 20, gap: 10 }}>
          <GradientButton label="확인" onPress={onDismiss} />
          <SecondaryButton label="🎮 같이 할 친구 초대하기" onPress={handleShare} style={{ width: '100%' }} />
        </View>
      </ScrollView>
    </View>
  );
}
const ss = StyleSheet.create({
  scrollContent:    { flexGrow: 1, padding: 20, paddingBottom: 40, alignItems: 'center' },
  successMarkWrap:  { alignItems: 'center', marginTop: 12, marginBottom: 24 },
  successMark:      { width: 104, height: 104, borderRadius: 52, backgroundColor: GOLD,
                      justifyContent: 'center', alignItems: 'center',
                      shadowColor: GOLD, shadowOffset: { width: 0, height: 12 },
                      shadowOpacity: 0.35, shadowRadius: 24, elevation: 8 },
  successCheck:     { color: BG, fontSize: 44, fontWeight: '900' },
  title:            { color: TEXT, fontSize: 23, fontWeight: '800', marginTop: 20 },
  sub:              { color: TEXT_SEC, fontSize: 13.5, textAlign: 'center', marginTop: 6 },
  ticketCard:       { width: '100%', backgroundColor: SURFACE, borderRadius: 18,
                      borderWidth: 1, borderColor: GOLD + '33', overflow: 'hidden' },
  ticketHeader:     { flexDirection: 'row', alignItems: 'center', gap: 12, padding: 16,
                      borderBottomWidth: 1, borderBottomColor: BORDER, borderStyle: 'dashed' },
  ticketThumb:      { width: 52, height: 52, borderRadius: 12 },
  ticketName:       { color: TEXT, fontSize: 15, fontWeight: '700' },
  ticketStore:      { color: TEXT_SEC, fontSize: 12, marginTop: 3 },
  ticketBody:       { padding: 16 },
  summaryRow:       { flexDirection: 'row', justifyContent: 'space-between',
                      alignItems: 'center', paddingVertical: 7 },
  summaryLabelRow:  { flexDirection: 'row', alignItems: 'center', gap: 6 },
  summaryLabel:     { color: TEXT_MUTED, fontSize: 13 },
  summaryValue:     { color: TEXT, fontSize: 13, fontWeight: '600' },
  noticeBox:        { width: '100%', backgroundColor: GOLD + '0D', borderRadius: 10, padding: 14,
                      borderWidth: 1, borderColor: BORDER, marginTop: 16 },
  noticeText:       { color: TEXT_SEC, fontSize: 12, lineHeight: 18 },
});

export default function ThemeDetailScreen() {
  const navigation = useNavigation();
  const route      = useRoute();
  const insets     = useSafeAreaInsets();
  const { user, profile } = useAuth();

  const paramProduct = normalizeProduct(route.params?.product || {});
  // 78차: 크루/알림 등에서 { id: productId }만 넘기고 navigate하는 곳들(CrewScreen의
  // 테마추천 카드, 즐겨찾기 가격변경 알림 등)이 있는데, 이 화면은 route.params.product를
  // 그대로만 쓰고 있어서 이름/가격/이미지가 전부 빈 채로 보이는 반쪽짜리 화면이 되고
  // 있었음 — 최소 정보(name 없음)만 있으면 productId로 전체 데이터를 다시 조회.
  const needsFetch = !paramProduct.name && !!paramProduct.id;
  const [fetchedProduct, setFetchedProduct] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(needsFetch);
  const [fetchError,     setFetchError]     = useState(false);
  // 79차: [버그 수정] getProductById가 예외 없이 null을 정상 반환하는 경우(테마가
  // 이후 소프트삭제됨 — 크루 게시판 테마추천 카드, PICK 등 id만 들고 진입하는 경로에서
  // 재현)를 fetchError와 구분 안 하고 있어서, 그냥 {id}뿐인 빈 product로 조용히
  // 렌더되고 있었음(크루 게시판 재정독 fork로 발견, PICK에서 이미 발견된 것과 동일
  // 유형). "불러오지 못함(재시도 가능)"과 "삭제됨(재시도 무의미)"을 구분.
  const [notFound,       setNotFound]       = useState(false);

  const fetchProduct = useCallback(() => {
    if (!needsFetch) return;
    let alive = true;
    setLoadingProduct(true);
    setFetchError(false);
    setNotFound(false);
    getProductById(paramProduct.id, { uid: user?.uid, managedStoreIds: profile?.managedStores })
      .then(p => { if (alive) { if (p) setFetchedProduct(p); else setNotFound(true); } })
      .catch(() => { if (alive) setFetchError(true); })
      .finally(() => { if (alive) setLoadingProduct(false); });
    return () => { alive = false; };
  }, [needsFetch, paramProduct.id]);

  useEffect(() => fetchProduct(), [fetchProduct]);

  const product = fetchedProduct ? normalizeProduct(fetchedProduct) : paramProduct;
  // 80차 후속: 체험형 공연은 난이도/인원별 총액 가격표 대신 활동성/1인당 가격 표시
  const isShowFormat = product?.bookingFormat === 'show';

  const [reviews,        setReviews]        = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(true);
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [showSheet,      setShowSheet]      = useState(false);
  const [successData,    setSuccessData]    = useState(null);

  // 80차 후속: 확인된 미성년자가 19금 테마에 딥링크로 들어오면 아래서 차단 화면으로
  // 대체되는데, 그 전에 조회수 증가/리뷰 조회가 먼저 실행돼 낭비되던 것 — 두 effect
  // 모두 이 경우엔 아무 것도 안 하도록 가드(fork로 발견).
  const isBlockedForMinor = product.isAdultOnly && isConfirmedMinorBirth(profile?.birth);

  // 55차: 테마 상세 진입 시 조회수 +1 (무음 처리)
  useEffect(() => {
    if (!product.id || isBlockedForMinor) return;
    incrementViewCount(product.id).catch(() => {});
  }, [product.id, isBlockedForMinor]);

  useEffect(() => {
    if (!product.id || isBlockedForMinor) return;
    setReviewsLoading(true);
    getReviewsByProduct(product.id, 20)
      .then(setReviews)
      .catch(() => {})
      .finally(() => setReviewsLoading(false));
  }, [product.id, isBlockedForMinor]);

  // 78차 47차: 최고가까지 같이 보여주면 거부감이 생긴다는 의견 — 최저가만 "N원~" 형태로 노출
  const priceRange = (() => {
    if (!product.pricing?.length) return null;
    const prices = product.pricing.map(p => Number(p.price)).filter(Boolean);
    if (!prices.length) return null;
    const min = Math.min(...prices);
    return `${min.toLocaleString()}원~`;
  })();

  // 주소 조합
  // 78차 48차: product.address는 애초에 존재한 적 없는 필드명이라 항상 undefined였고,
  // 실제 상세주소는 product.addressDetail(productService.js에서 이번에 추가로 매핑) —
  // "서울 광진"까지만 표시/검색되던 버그의 원인. 상세주소가 있으면 그걸로, 없으면
  // 매장명으로 지도 검색 정확도를 높임(openMapApp 호출부 참고).
  const fullAddress = [product.city, product.district, product.addressDetail]
    .filter(Boolean).join(' ');
  // 75차: 장르 배지 색상 + 영문 병기 (design_handoff_unlock 디자인 시스템)
  const genreMeta = product.genre ? getGenreMeta(product.genre) : null;

  const handleSuccess = (data) => {
    setShowSheet(false);
    setSuccessData(data);
  };

  // 49차: 예약 완료 시 SuccessScreen을 전체 화면으로 표시
  if (successData) {
    return (
      <View style={{ flex: 1, backgroundColor: BG, paddingTop: insets.top }}>
        <SuccessScreen
          data={successData}
          product={product}
          navigation={navigation}
          onDismiss={() => {
            setSuccessData(null);
            navigation.getParent()?.navigate('Home');
          }}
        />
      </View>
    );
  }

  if (loadingProduct) return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader showBack centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>테마 상세</Text>} />
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <ActivityIndicator color={GOLD} size="large" />
      </View>
    </View>
  );

  // 79차: 삭제된 테마 — 재시도해도 다시 나타나지 않으므로 "다시 시도" 대신 안내만.
  if (notFound && !product.name) return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader showBack centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>테마 상세</Text>} />
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, gap: 12 }}>
        <Text style={{ color: TEXT_MUTED, fontSize: 14, textAlign: 'center' }}>
          삭제되었거나 존재하지 않는 테마예요.
        </Text>
      </View>
    </View>
  );

  // 78차 32차: id만 들고 진입한 경우(크루 추천/가격변경 알림 등) 조회 실패 시 이름/이미지
  // 없이 텅 빈 화면만 보이던 것 — 재시도 안내로 교체.
  if (fetchError && !product.name) return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader showBack centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>테마 상세</Text>} />
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, gap: 12 }}>
        <Text style={{ color: TEXT_MUTED, fontSize: 14, textAlign: 'center' }}>
          테마 정보를 불러오지 못했어요.
        </Text>
        <TouchableOpacity onPress={fetchProduct}>
          <Text style={{ color: GOLD, fontSize: 14, fontWeight: '700' }}>다시 시도</Text>
        </TouchableOpacity>
      </View>
    </View>
  );

  // 80차 후속: [기능 추가] 목록(예약탭/홈/모집게시판)에서는 확인된 미성년자에게 19금
  // 테마를 숨기고 있는데, PICK 배너·크루 게시판 테마추천 카드·알림 등으로 딥링크
  // 진입하면 이 화면이 그 필터를 안 거쳐 그대로 노출되는 사각지대가 있었음(fork로
  // 발견) — getProductById()나 그 7개 호출부 전부를 고치는 대신, 실제 "새 콘텐츠
  // 발견" 경로인 이 상세 화면 렌더링 단계에서만 차단(예약 내역/내 리뷰/즐겨찾기 등
  // 본인 과거 데이터 화면은 의도적으로 그대로 둠 — 거기서 숨기면 오히려 혼란스러움).
  if (isBlockedForMinor) return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader showBack centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>테마 상세</Text>} />
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, gap: 12 }}>
        <Text style={{ color: COLORS.danger, fontSize: 15, fontWeight: '700', textAlign: 'center' }}>🔞 19세 이상만 볼 수 있는 테마예요</Text>
        <Text style={{ color: TEXT_MUTED, fontSize: 13, textAlign: 'center' }}>
          이 테마는 만 19세 이상만 이용할 수 있어요.
        </Text>
      </View>
    </View>
  );

  // 80차 후속: "예약 완료 후에만 공유 가능"에서 "둘러보는 중에도 바로 공유 가능"으로
  // 확장 — 오픈채팅방 등에 이 소개 페이지(themeShareCF)를 미리 뿌려서 앱을 아직 안
  // 쓰는 사람도 다운로드하도록 유도하는 게 목적이라 예약 여부와 무관해야 함.
  const handleShareTheme = async () => {
    try {
      const shareUrl = `https://unlockapp.co.kr/t/${product.id}`;
      await Share.share({
        message: `[방탈출 같이 해요! 🔐] ${product.name}\n${shareUrl}`,
        url: shareUrl,
        title: `${product.name} | UNLOCK`,
      });
    } catch {}
  };

  return (
    <View style={{ flex: 1, backgroundColor: BG }}>
      <AppHeader showBack
        centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }} numberOfLines={1}>{product.name}</Text>}
        rightElement={
          <TouchableOpacity onPress={handleShareTheme} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
            <ShareIcon size={20} />
          </TouchableOpacity>
        } />

      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ paddingBottom: 130 }}
        showsVerticalScrollIndicator={false}
      >
        <View style={s.heroWrap}>
          {product.thumbnailUrl
            ? <Image source={{ uri: product.thumbnailUrl }} style={s.heroImg} contentFit="cover" />
            : <View style={[s.heroImg, s.heroPlaceholder]}><LogoMark size={56} /></View>
          }
          <LinearGradient
            colors={['rgba(10,10,20,0.15)', COLORS.bg]}
            locations={[0.4, 1]}
            style={s.heroOverlay}
            pointerEvents="none"
          />
          <View style={s.heroBottom}>
            <View style={s.heroBadgeRow}>
              {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(방탈출/체험형, 필수) → ②19금 → ③장르 */}
              {isShowFormat ? (
                <View style={[s.genreBadge, { borderColor: COLORS.blue+'55' }]}>
                  <Text style={[s.genreBadgeTxt, { color: COLORS.blue }]}>체험형</Text>
                </View>
              ) : (
                <View style={[s.genreBadge, { borderColor: COLORS.teal+'55' }]}>
                  <Text style={[s.genreBadgeTxt, { color: COLORS.teal }]}>방탈출</Text>
                </View>
              )}
              {/* 80차 후속: 테마상세 히어로에 체험형/합석 뱃지가 없었음(예약 도중 "회차 정원"
                  텍스트로만 간접 노출) — 카드들과 동일하게 형식 배지 옆에 명시 */}
              {isShowFormat && (
                <View style={[s.genreBadge, { borderColor: COLORS.purple+'55' }]}>
                  <Text style={[s.genreBadgeTxt, { color: COLORS.purple }]}>{getSeatingTypeLabel(product.seatingType)}</Text>
                </View>
              )}
              {product.isAdultOnly && (
                <View style={[s.genreBadge, { borderColor: COLORS.danger+'55' }]}>
                  <Text style={[s.genreBadgeTxt, { color: COLORS.danger }]}>19금</Text>
                </View>
              )}
              {genreMeta ? (
                <View style={[s.genreBadge, { borderColor: genreMeta.color+'55' }]}>
                  <Text style={[s.genreBadgeTxt, { color: genreMeta.color }]}>
                    {product.genre}{genreMeta.en ? ` · ${genreMeta.en}` : ''}
                  </Text>
                </View>
              ) : null}
              <View style={s.genreBadge}>
                <Text style={s.genreBadgeTxt}>{product.minPeople || 1}~{product.maxPeople || '?'}인</Text>
              </View>
            </View>
            <Text style={s.themeName}>{product.name}</Text>
            <View style={s.heroMetaRow}>
              <IconLabel Icon={MenuStoreIcon} size={12} color="#C8C8D2" textStyle={s.storeNameHero} numberOfLines={1}>
                {product.storeName}{product.branchName ? ` · ${product.branchName}` : ''}
              </IconLabel>
              <DifficultyDots difficulty={isShowFormat ? product.activityLevel : product.difficulty} />
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>
                <StarRating rating={product.rating} size={13} />
                <Text style={s.ratingVal}>{(product.rating || 0).toFixed(1)}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={s.body}>
          {/* 72차: 매장 일시 휴업 안내 배너 */}
          {product.isPaused && (
            <View style={s.pausedBanner}>
              <NoEntryIcon size={18} color={COLORS.red} />
              <Text style={s.pausedBannerTxt}>이 매장은 현재 일시 휴업 중이에요. 예약이 잠시 중단됩니다.</Text>
            </View>
          )}
          <View style={s.titleSection}>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
              <TouchableOpacity
                onPress={() => navigation.navigate('StoreDetail', { storeId: product.storeId })}
                activeOpacity={0.7}
              >
                <Text style={[s.storeName, { textDecorationLine: 'underline' }]}>
                  매장 정보 보기 →
                </Text>
              </TouchableOpacity>
              {/* 72차: 이 테마(매장)에 대한 문의 작성 */}
              {!!product.storeId && (
                <TouchableOpacity
                  onPress={() => {
                    if (!user) { navigation.navigate('Login'); return; }
                    navigation.navigate('WriteInquiry', {
                      targetType: 'store',
                      storeId: product.storeId,
                      context: { type: 'theme', productId: product.id, productName: product.name },
                    });
                  }}
                  activeOpacity={0.7}
                >
                  <IconLabel Icon={MenuInquiryIcon} size={12} color={TEXT_SEC} textStyle={s.storeName}>문의하기</IconLabel>
                </TouchableOpacity>
              )}
            </View>
            {fullAddress ? (
              <IconLabel Icon={LocationIcon} size={11} color={TEXT_MUTED} textStyle={s.location}>{fullAddress}</IconLabel>
            ) : (
              <IconLabel Icon={LocationIcon} size={11} color={TEXT_MUTED} textStyle={s.location}>{product.city || ''}{product.district ? ` ${product.district}` : ''}</IconLabel>
            )}
            <Text style={s.reviewCount}>리뷰 {product.reviewCount || 0}개</Text>
          </View>

          <View style={s.badgeGrid}>
            <InfoBadge Icon={StopwatchIcon} label="플레이 시간" value={`${product.duration || 60}분`} />
            <InfoBadge Icon={PeopleIcon} label="인원" value={`${product.minPeople || 1}~${product.maxPeople || '?'}명`} />
          </View>
          <View style={[s.badgeGrid, { marginTop: 10 }]}>
            {/* 80차 후속: 체험형 공연은 "난이도" 대신 "활동성"(같은 게이지 컴포넌트 재사용) */}
            {isShowFormat ? (
              <InfoBadge Icon={DifficultyTargetIcon} label="활동성" value={getActivityLabel(product.activityLevel)} valueColor={getActivityColor(product.activityLevel)}
                extra={
                  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 4 }}>
                    <DifficultyLockIcon size={16} color={getActivityColor(product.activityLevel)} />
                    <DifficultyGaugeDots difficulty={product.activityLevel} color={getActivityColor(product.activityLevel)} />
                  </View>
                } />
            ) : (
              <InfoBadge Icon={DifficultyTargetIcon} label="난이도" value={getDifficultyLabel(product.difficulty)} valueColor={getDifficultyColor(product.difficulty)}
                extra={
                  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 4 }}>
                    <DifficultyLockIcon size={16} color={getDifficultyColor(product.difficulty)} />
                    <DifficultyGaugeDots difficulty={product.difficulty} color={getDifficultyColor(product.difficulty)} />
                  </View>
                } />
            )}
            <InfoBadge Icon={GenreIcon} label="장르"
              value={genreMeta ? `${product.genre} · ${genreMeta.en}` : '-'}
              valueColor={genreMeta?.color} />
          </View>

          {/* 47차: "지금 바로 예약하기" 배너 제거됨 */}

          {product.description ? (
            <View style={s.section}>
              <SectionHeader title="테마 소개" />
              <Text style={s.description}>{product.description}</Text>
            </View>
          ) : null}

          {/* 80차 후속: 체험형 공연은 인원수별 총액 표 대신 1인당 단가 한 줄만 표시 */}
          {isShowFormat ? (
            product.pricePerPerson > 0 && (
              <View style={s.section}>
                <SectionHeader title="가격" />
                <View style={s.priceTable}>
                  <View style={pr.row}>
                    <Text style={pr.people}>1인당</Text>
                    <Text style={pr.price}>{Number(product.pricePerPerson).toLocaleString()}원</Text>
                  </View>
                </View>
                {/* 80차 후속: 정원 표시 — 예약 도중 "N석 남음"으로만 간접 노출되던 것을 정적 정보로 명시 */}
                {product.capacity > 0 && (
                  <Text style={s.priceRangeNote}>* 회차 정원 {product.capacity}명 · {getSeatingTypeLabel(product.seatingType)} · 현장 결제</Text>
                )}
                {!(product.capacity > 0) && <Text style={s.priceRangeNote}>* 현장 결제</Text>}
              </View>
            )
          ) : product.pricing?.length > 0 ? (
            <View style={s.section}>
              <SectionHeader title="가격표" />
              <View style={s.priceTable}>
                {product.pricing.map((p, i) => (
                  <PriceRow key={i} people={p.people} price={p.price} />
                ))}
              </View>
              {priceRange && (
                <Text style={s.priceRangeNote}>* {priceRange} · 현장 결제</Text>
              )}
            </View>
          ) : null}

          {/* 80차 후속: 19금 테마 현장 확인 고지 — 앱은 생년월일 자기신고만 확인하므로,
              최종 확인은 현장 신분증 검사로 이뤄질 수 있다는 걸 명확히 함(책임소재 안내). */}
          {product.isAdultOnly && (
            <View style={s.section}>
              <Text style={[s.priceRangeNote, { color: COLORS.danger, textAlign: 'left' }]}>
                🔞 만 19세 이상만 예약 가능한 테마입니다. 현장에서 신분증 확인 시 만 19세 미만이면 입장이 제한될 수 있어요.
              </Text>
            </View>
          )}

          {/* 80차 후속: 체험형 공연 전용 — 유의사항/환불 정책 */}
          {isShowFormat && !!product.notices && (
            <View style={s.section}>
              <SectionHeader title="유의사항" />
              {product.notices.split('\n').filter(Boolean).map((line, i) => (
                <Text key={i} style={s.description}>· {line}</Text>
              ))}
            </View>
          )}
          {isShowFormat && !!product.refundPolicy && (
            <View style={s.section}>
              <SectionHeader title="환불 정책" />
              <Text style={s.description}>{product.refundPolicy}</Text>
            </View>
          )}

          {/* 47차: 주소 + 지도 앱으로 열기 */}
          {(fullAddress || product.city) ? (
            <View style={s.section}>
              <SectionHeader title="위치" />
              <View style={s.locationCard}>
                <View style={s.locationInfo}>
                  <IconLabel Icon={LocationIcon} size={13} color={TEXT} textStyle={s.locationAddress}>
                    {fullAddress || `${product.city} ${product.district || ''}`.trim()}
                  </IconLabel>
                  {product.storeName ? (
                    <IconLabel Icon={MenuStoreIcon} size={12} color={TEXT_MUTED} textStyle={s.locationStoreName}>{product.storeName}</IconLabel>
                  ) : null}
                </View>
                <TouchableOpacity
                  style={s.mapBtn}
                  onPress={() => openMapApp(fullAddress, product.storeName)}
                  activeOpacity={0.8}
                >
                  <Text style={s.mapBtnIcon}>🗺️</Text>
                  <Text style={s.mapBtnText}>지도 앱으로{'\n'}열기</Text>
                </TouchableOpacity>
              </View>
            </View>
          ) : null}

          <View style={s.section}>
            <SectionHeader title="리뷰" count={reviews.length} />
            <ReviewList
              reviews={showAllReviews ? reviews : reviews.slice(0, 3)}
              loading={reviewsLoading}
              emptyText="아직 리뷰가 없습니다"
              currentUser={user}
              currentProfile={profile}
            />
            {reviews.length > 3 && (
              <TouchableOpacity
                style={s.moreReviewBtn}
                onPress={() => setShowAllReviews(v => !v)}
              >
                <Text style={s.moreReviewTxt}>
                  {showAllReviews ? '▲ 접기' : `▼ 리뷰 ${reviews.length - 3}개 더 보기`}
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </ScrollView>

      <View style={[s.footer, { paddingBottom: insets.bottom + 16 }]}>
        {priceRange && (
          <View style={s.footerPrice}>
            <Text style={s.footerPriceLabel}>최저</Text>
            <Text style={s.footerPriceVal}>{priceRange}</Text>
          </View>
        )}
        <GradientButton
          style={{ flex: 2 }}
          label={product.isPaused ? '휴업중' : '예약하기'}
          Icon={product.isPaused ? NoEntryIcon : BookingLockIcon}
          onPress={() => setShowSheet(true)}
          disabled={product.isPaused}
        />
      </View>

      <QuickBookSheet
        visible={showSheet}
        product={product}
        onClose={() => setShowSheet(false)}
        onSuccess={handleSuccess}
        navigation={navigation}
      />
    </View>
  );
}

const s = StyleSheet.create({
  // 77차: design 폴더 스펙 — 히어로 290, 하단 그라디언트 스크림 위 제목/매장/난이도/별점 오버레이
  heroWrap:        { width: '100%', height: 290, position: 'relative' },
  heroImg:         { width: '100%', height: '100%' },
  heroPlaceholder: { backgroundColor: SURFACE2, justifyContent: 'center', alignItems: 'center' },
  heroOverlay:     { ...StyleSheet.absoluteFillObject },
  heroBottom:      { position: 'absolute', bottom: 16, left: 20, right: 20 },
  heroBadgeRow:    { flexDirection: 'row', gap: 6, marginBottom: 8 },
  heroMetaRow:     { flexDirection: 'row', alignItems: 'center', gap: 10, marginTop: 6 },
  storeNameHero:   { color: '#C8C8D2', fontSize: 13, flexShrink: 1 },
  genreBadge:      { borderWidth: 1, borderColor: 'rgba(255,255,255,0.14)',
                     borderRadius: 5, paddingHorizontal: 8, paddingVertical: 3 },
  genreBadgeTxt:   { fontSize: 10, fontWeight: '700', color: TEXT_SEC },

  body:            { padding: 20 },
  titleSection:    { marginBottom: 20 },
  themeName:       { color: TEXT, fontSize: 24, fontWeight: '900', letterSpacing: 0.3 },
  storeName:       { color: TEXT_SEC, fontSize: 13, marginBottom: 2 },
  location:        { color: TEXT_MUTED, fontSize: 12, marginTop: 6, marginBottom: 4 },
  ratingVal:       { color: '#D6D6DE', fontSize: 12, fontWeight: '700' },
  reviewCount:     { color: TEXT_MUTED, fontSize: 12 },

  badgeGrid:       { flexDirection: 'row', gap: 10 },
  section:         { marginTop: 28 },
  description:     { color: TEXT_SEC, fontSize: 14, lineHeight: 22 },

  priceTable:      { backgroundColor: SURFACE2, borderRadius: 12, paddingHorizontal: 16,
                     borderWidth: 1, borderColor: BORDER, overflow: 'hidden' },
  priceRangeNote:  { color: TEXT_MUTED, fontSize: 11, marginTop: 8, textAlign: 'right' },

  // 47차: 위치 카드
  locationCard:    { backgroundColor: SURFACE2, borderRadius: 12, padding: 14,
                     borderWidth: 1, borderColor: BORDER,
                     flexDirection: 'row', alignItems: 'center', gap: 12 },
  locationInfo:    { flex: 1 },
  locationAddress: { color: TEXT, fontSize: 14, fontWeight: '600', lineHeight: 20, marginBottom: 4 },
  locationStoreName:{ color: TEXT_MUTED, fontSize: 12 },
  mapBtn:          { backgroundColor: GOLD + '18', borderRadius: 10, borderWidth: 1,
                     borderColor: GOLD + '44', paddingVertical: 10, paddingHorizontal: 12,
                     alignItems: 'center', gap: 4 },
  mapBtnIcon:      { fontSize: 20 },
  mapBtnText:      { color: GOLD, fontSize: 10, fontWeight: '700', textAlign: 'center' },

  moreReviewBtn:   { alignItems: 'center', paddingVertical: 12, backgroundColor: SURFACE2,
                     borderRadius: 10, borderWidth: 1, borderColor: BORDER },
  moreReviewTxt:   { color: GOLD, fontSize: 13, fontWeight: '700' },

  footer:          { position: 'absolute', bottom: 0, left: 0, right: 0,
                     backgroundColor: SURFACE, borderTopWidth: 1, borderTopColor: BORDER,
                     paddingHorizontal: 20, paddingTop: 14,
                     flexDirection: 'row', alignItems: 'center', gap: 14 },
  footerPrice:     { flex: 1 },
  footerPriceLabel:{ color: TEXT_MUTED, fontSize: 11 },
  footerPriceVal:  { color: GOLD, fontSize: 16, fontWeight: '900' },
  // 72차: 예약하기 버튼은 GradientButton 컴포넌트로 교체 — 아래 3개 스타일은 삭제됨
  pausedBanner:    { flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: '#3a2a12',
                     borderWidth: 1, borderColor: '#7a5a20', borderRadius: 10, padding: 12, marginBottom: 16 },
  pausedBannerTxt: { color: '#e8b95c', fontSize: 13, fontWeight: '700', flex: 1 },
});